import apiServices from "../apiServices";
import { validateOrThrowApiResponse } from "../response-validator";

const recommendGameAPI = {

    createRecommendGame(payload: { gameId: number[] }) {
        return apiServices
            .post(
                `/api/recommend-game`,
                { gameId: payload.gameId },
                {
                    headers: {
                        Accept: "application/json",
                    },
                }
            )
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error createRecommendGame:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    getAllRecommendGames() {
        return apiServices
            .get(`/api/recommend-game`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error getAllRecommendGames:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    updateNoRecommendGame(payload: { gameId: number | string; no: number }) {
        return apiServices
            .patch(
                `/api/recommend-game/no`,
                { gameId: payload.gameId, no: payload.no },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                },
            )
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error updateNoRecommendGame:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

    deleteRecommendGame(gameId: number | string) {
        return apiServices
            .delete(`/api/recommend-game/game/${gameId}`, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error deleteRecommendGame:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    }

}

export default recommendGameAPI;